import React, { forwardRef, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { ButtonReg } from 'atoms/Buttons'
import { FormSelect } from 'atoms/Inputs'
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
  BaseDatePickerInput,
  Input,
  TextArea,
  RequiredSign,
  Error,
} from './styles'
import * as _ from 'lodash'

export class OutpitRainfallModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
    }
    this.errorsRef = {}
  }

  onSubmit() {
    this.setState({ errors: {} })
    const { valid, errors } = this.isValid()
    if (valid) {
      const { rainfallData, fnSubmit } = this.props
      fnSubmit(rainfallData)
    } else {
      this.setState({ errors }, () => {
        this.errorsRef[`${Object.keys(errors)[0]}`].focus()
      })
    }
  }

  isValid() {
    const { rainfallData } = this.props
    let errors = {}
    const validatingFields = _.pick(rainfallData, [
      'companyId',
      'contractorId',
      'pit',
      'rainFrom',
      'rainTo',
      'totalRain',
      'amount',
    ])
    Object.keys(validatingFields).forEach((key) => {
      const numberValue = ['totalRain', 'amount']
      const value = validatingFields[key]
      if (numberValue.includes(key) ? Number(value) < 1 : !value) {
        errors[key] = {
          ref: key,
          message: 'Field ini tidak boleh kosong',
        }
      }
    })

    // totalSlippery cannot be 0 when slipperyFrom and slipperyTo are not empty
    if (
      (!!rainfallData.slipperyFrom || !!rainfallData.slipperyTo) &&
      Number(rainfallData.totalSlippery) <= 0
    ) {
      errors['totalSlippery'] = {
        ref: 'totalSlippery',
        message:
          'Field ini tidak boleh kosong jika `Slippery From` dan `Slippery To` tidak kosong',
      }
    }

    return { valid: Object.keys(errors).length < 1, errors }
  }
  render() {
    const { theme, rainfallData, isDisabled, fnChange, companiesList } =
      this.props
    const { errors } = this.state
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      arrowPos: 'calc(100% - 12px)',
      arrowSize: '16px',
    }

    const company = companiesList.find((c) => c.id === rainfallData.companyId)
    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
      <BaseDatePickerInput
        onClick={onClick}
        ref={ref}
      >
        {value}
      </BaseDatePickerInput>
    ))

    return (
      <MainWrapper>
        <ModalHead>
          <Label
            lineheight={'29px'}
            size={'24px'}
            mb={'0px'}
          >
            {rainfallData.hasOwnProperty('id') ? 'Edit ' : 'Add New '}
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                >
                  Company
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select Company'}
                  onChangeVal={(e) => fnChange(+e.target.value, 'companyId')}
                  options={companiesList}
                  value={rainfallData.companyId}
                  ref={(ref) => (this.errorsRef['companyId'] = ref)}
                  valField={'id'}
                  dispField={'name'}
                  {...inputConfig}
                />
                {'companyId' in errors && (
                  <Error>{errors.companyId.message}</Error>
                )}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                >
                  Contractor
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select Contractor'}
                  onChangeVal={(e) => fnChange(e.target.value, 'contractorId')}
                  options={company ? company.contractors : []}
                  value={rainfallData.contractorId}
                  ref={(ref) => (this.errorsRef['contractorId'] = ref)}
                  valField={'id'}
                  dispField={'name'}
                  {...inputConfig}
                />
                {'contractorId' in errors && (
                  <Error>{errors.contractorId.message}</Error>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Pit
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  placeholder="Enter Pit"
                  type="text"
                  value={rainfallData.pit}
                  onChange={(e) => fnChange(e.target.value, 'pit')}
                  ref={(ref) => (this.errorsRef['pit'] = ref)}
                />
                {'pit' in errors && <Error>{errors.pit.message}</Error>}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Date
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    selected={
                      rainfallData.date
                        ? moment(rainfallData.date).toDate()
                        : null
                    }
                    onChange={(date) =>
                      fnChange(moment(date).format('YYYY-MM-DD'), 'date')
                    }
                    ref={(ref) => (this.errorsRef['date'] = ref)}
                    dateFormat={'yyyy-MM-dd'}
                    customInput={<DatePickerInput />}
                  />
                </div>
                {'date' in errors && <Error>{errors.date.message}</Error>}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Rain From
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    selected={
                      rainfallData.rainFrom
                        ? moment(rainfallData.rainFrom).toDate()
                        : null
                    }
                    onChange={(date) =>
                      fnChange(
                        moment(date).format('YYYY/MM/DD HH:mm'),
                        'rainFrom'
                      )
                    }
                    ref={(ref) => (this.errorsRef['rainFrom'] = ref)}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
                {'rainFrom' in errors && (
                  <Error>{errors.rainFrom.message}</Error>
                )}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Rain To
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    selected={
                      rainfallData.rainTo
                        ? moment(rainfallData.rainTo).toDate()
                        : null
                    }
                    onChange={(date) =>
                      fnChange(
                        moment(date).format('YYYY/MM/DD HH:mm'),
                        'rainTo'
                      )
                    }
                    ref={(ref) => (this.errorsRef['rainTo'] = ref)}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
                {'rainTo' in errors && <Error>{errors.rainTo.message}</Error>}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Amount
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  placeholder="Enter Amount"
                  type="number"
                  value={rainfallData.amount}
                  onChange={(e) => fnChange(Number(e.target.value), 'amount')}
                  ref={(ref) => (this.errorsRef['amount'] = ref)}
                />
                {'amount' in errors && <Error>{errors.amount.message}</Error>}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Total Rain
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  value={rainfallData.totalRain}
                  onChange={(e) =>
                    fnChange(Number(e.target.value), 'totalRain')
                  }
                  ref={(ref) => (this.errorsRef['totalRain'] = ref)}
                />
                {'totalRain' in errors && (
                  <Error>{errors.totalRain.message}</Error>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Slippery From
                </Label>
                <div>
                  <DatePicker
                    selected={
                      rainfallData.slipperyFrom
                        ? moment(rainfallData.slipperyFrom).toDate()
                        : null
                    }
                    onChange={(date) =>
                      fnChange(
                        date ? moment(date).format('YYYY/MM/DD HH:mm') : null,
                        'slipperyFrom'
                      )
                    }
                    ref={(ref) => (this.errorsRef['slipperyFrom'] = ref)}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                    isClearable
                  />
                </div>
                {'slipperyFrom' in errors && (
                  <Error>{errors.slipperyFrom.message}</Error>
                )}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Slippery To
                </Label>
                <div>
                  <DatePicker
                    selected={
                      rainfallData.slipperyTo
                        ? moment(rainfallData.slipperyTo).toDate()
                        : null
                    }
                    onChange={(date) =>
                      fnChange(
                        date ? moment(date).format('YYYY/MM/DD HH:mm') : null,
                        'slipperyTo'
                      )
                    }
                    ref={(ref) => (this.errorsRef['slipperyTo'] = ref)}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                    isClearable
                  />
                </div>
                {'slipperyTo' in errors && (
                  <Error>{errors.slipperyTo.message}</Error>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Total Slippery
                </Label>
                <Input
                  type="number"
                  value={rainfallData.totalSlippery}
                  onChange={(e) => fnChange(e.target.value, 'totalSlippery')}
                  ref={(ref) => (this.errorsRef['totalSlippery'] = ref)}
                />
                {'totalSlippery' in errors && (
                  <Error>{errors.totalSlippery.message}</Error>
                )}
              </div>
            </div>

            <Label
              lineheight={'14px'}
              size={'12px'}
              mt={'16px'}
            >
              Remark
            </Label>
            <TextArea
              placeholder="Enter Remark"
              value={rainfallData.remark}
              onChange={(e) => fnChange(e.target.value, 'remark')}
            />
          </InputRow>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg
            onClick={this.props.fnSwitch}
            disabled={isDisabled}
            transparent
            btnTxt={'Cancel'}
          />
          <ButtonReg
            onClick={this.onSubmit.bind(this)}
            disabled={isDisabled}
            btnTxt={isDisabled ? 'Submitting...' : 'Submit'}
          />
        </ModalFooter>
      </MainWrapper>
    )
  }
}

export default withTheme(OutpitRainfallModal)
